import { Link } from "react-router-dom";
import Logo from "@/components/site/Logo";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#45281A] text-[#FCEFE2] relative overflow-hidden">
      {/* Oversized editorial wordmark */}
      <div className="absolute inset-x-0 bottom-0 pointer-events-none select-none opacity-[0.06]">
        <div className="font-serif italic text-[20vw] leading-[0.8] tracking-tighter text-[#FCEFE2] text-center whitespace-nowrap">
          Witali Albrecht
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Logo variant="light" />
            <p className="mt-6 text-[#FCEFE2]/75 leading-relaxed max-w-md text-[15px]">
              Ein sicherer Raum für Klarheit, Veränderung und innere Balance –
              psychologische Beratung in Lünen, online und nach Vereinbarung
              persönlich.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] tracking-[0.25em] uppercase text-[#FCEFE2]/60 mb-4">
              Schwerpunkte
            </div>
            <ul className="space-y-2 text-[#FCEFE2]/85 text-sm">
              <li>Suchtprävention</li>
              <li>Persönliche Entwicklung</li>
              <li>Ängste & Unsicherheiten</li>
              <li>Partnerschaft & Beziehungen</li>
              <li>Achtsamkeit & innere Balance</li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] tracking-[0.25em] uppercase text-[#FCEFE2]/60 mb-4">
              Kontakt
            </div>
            <ul className="space-y-2 text-[#FCEFE2]/85 text-sm">
              <li>witalialbrecht21@web.de</li>
              <li>+49 177 1973430</li>
              <li>Lünen · Online und nach Vereinbarung persönlich</li>
            </ul>
            <div className="mt-6 flex flex-wrap gap-x-6 gap-y-2 text-sm">
              <Link to="/impressum" data-testid="footer-impressum" className="text-[#FCEFE2]/75 hover:text-[#FCEFE2] underline-offset-4 hover:underline">
                Impressum
              </Link>
              <Link to="/datenschutz" data-testid="footer-datenschutz" className="text-[#FCEFE2]/75 hover:text-[#FCEFE2] underline-offset-4 hover:underline">
                Datenschutz
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-16 pt-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-[#FCEFE2]/55">
          <div>© {new Date().getFullYear()} Witali Albrecht · Psychologische Beratung</div>
          <div>Keine Ausübung der Heilkunde und keine heilkundliche Psychotherapie.</div>
        </div>
      </div>
    </footer>
  );
}
